module.exports = __webpack_public_path__ + "img/Structures-Inspect-Medium.bc71bcab.png";